import {ref} from 'vue';

export default {
    install: (app, options) => {
        const users = ref([]);
        const types = ref([]);
        const statuses = ref([]);

        const loadInvoiceParametersByCompany = (companyId) => {
            window.lazy_axios.get(`/companies/${companyId}/invoices/parameters`)
                .then((response) => {
                    if (response.data.types) {
                        types.value = response.data.types;
                    }

                    if (response.data.users) {
                        users.value = response.data.users;
                    }

                    if (response.data.statuses) {
                        statuses.value = response.data.statuses;
                    }
                });
        };

        app.provide('company.invoice.users', users);
        app.provide('company.invoice.types', types);
        app.provide('company.invoice.statuses', statuses);

        app.provide('loadInvoiceParametersByCompany', loadInvoiceParametersByCompany);
    },
}
